export const LENGTH_TO_SHOW_DATA_ZOOM = 300;
const CHART_BOTTOM_OFFSET = 100;
const DATA_ZOOM_BOTTOM_OFFSET = 35;

export const DATA_ZOOM_OPTIONS = {
  grid: { bottom: CHART_BOTTOM_OFFSET },
  legend: {
    bottom: 0,
  },
  dataZoom: [
    {
      type: 'inside',
      bottom: DATA_ZOOM_BOTTOM_OFFSET,
    },
    {
      bottom: DATA_ZOOM_BOTTOM_OFFSET,
    },
  ],
};
